import { styled } from "theme/default/styled";

export const SFilterSelectorSelectContainer = styled.div`
  position: relative;
`;
